import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAllApplicationsDetails,
  fetchApplications,
  createApplication,
  getApplicationInformation,
  deleteApplication,
  updateApplication
} from '../actions/applicationactions';

const applicationSlice = createSlice({
  name: 'applications',
  initialState: {
    applications: [],
    status: 'idle', // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {}, // ✅ Keeping this in case we add manual reducers in the future
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        console.log("🔄 Fetching Applications - Pending...");
        state.status = 'loading';
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        console.log("✅ Applications Loaded: ", action.payload);
        state.status = 'succeeded';
        state.applications = action.payload;
      })
      .addCase(fetchApplications.rejected, (state, action) => {
        console.error("❌ Fetch Applications Failed:", action.payload);
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch applications';
      })
      // Fetch All Applications with Details
      .addCase(fetchAllApplicationsDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllApplicationsDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.applications = Array.isArray(action.payload) ? action.payload : []; // ✅ Ensure it's always an array
      })
      .addCase(fetchAllApplicationsDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch application details";
        state.applications = []; // ✅ Ensure applications is reset to an empty array
      })
      // Fetch Single Application
      .addCase(getApplicationInformation.pending, (state) => {
        console.log("🔄 Fetching Application Info...");
        state.status = 'loading';
      })
      .addCase(getApplicationInformation.fulfilled, (state, action) => {
  console.log("✅ Application Info Loaded:", action.payload);
  state.status = 'succeeded';

  const app = action.payload;

  // Make sure applications is always an array
  if (!Array.isArray(state.applications)) {
    state.applications = [];
  }

  const index = state.applications.findIndex(
    (a) => a.applicationId === app.applicationId
  );

  if (index !== -1) {
    // update existing
    state.applications[index] = app;
  } else {
    // or add if not present
    state.applications.push(app);
  }
})

      .addCase(getApplicationInformation.rejected, (state, action) => {
        console.error("❌ Fetch Application Info Failed:", action.payload);
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch application info';
      })
      // Create Application
      .addCase(createApplication.pending, (state) => {
        console.log("🔄 Creating Application...");
        state.status = 'loading';
      })
      .addCase(createApplication.fulfilled, (state, action) => {
        console.log("✅ Application Created:", action.payload);
        state.status = 'succeeded';
        state.applications.push(action.payload);
      })
      .addCase(createApplication.rejected, (state, action) => {
        console.error("❌ Create Application Failed:", action.payload);
        state.status = 'failed';
        state.error = action.payload || 'Failed to create application';
      })
        // Delete Application
      .addCase(deleteApplication.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteApplication.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Assuming each application has an 'id' property, remove the deleted application.
        const deletedId = action.meta.arg;
        state.applications = state.applications.filter(app => app.applicationId !== deletedId);
      })
      .addCase(deleteApplication.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to delete application';
      })
        .addCase(updateApplication.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateApplication.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // action.payload is array from getAllApplicationDetails
        state.applications = Array.isArray(action.payload)
          ? action.payload
          : state.applications;
      })
      .addCase(updateApplication.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to update application';
      });
  }
});

export default applicationSlice.reducer;
